// store/slices/creditNoteBalanceSlice.ts
import { createSlice } from '@reduxjs/toolkit';

const creditNoteBalanceSlice = createSlice({
  name: 'creditNoteBalance',
  initialState: {},
  reducers: {},
});

export default creditNoteBalanceSlice.reducer;
